export function scroll(top = 0, left = 0) {
  document.getElementById('root').scrollTo(top, left);
}
